module.exports = __webpack_public_path__ + "static/logo@100px-449ca074d29c3d00ed0d45fb99ed5311.png";